export enum TableMergeOption {
  INSERT_ONLY = "Insert only",
  UPDATE_ONLY = "Update only",
  UPDATE_AND_INSERT = "Update & Insert"
}
